import React, { Component } from 'react';

import compose from 'recompose/compose';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import TableBody from '@material-ui/core/TableBody'
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import {getObjectiveAvailabilityResponse} from '../../../../services/getObjectiveAvailabilityResponse'
import Grid from '@material-ui/core/Grid';
import PortletContent from '../Portletcomponents/PortletContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Typography from '@material-ui/core/Typography';
// Component styles
import styles from './styles';
import moment from 'moment'
import 'moment/locale/es'  
moment.locale('es')

Highcharts.setOptions ({
    lang: {
        months: [
            'Enero', 'Febrero', 'Marzo', 'Abril',
            'Mayo', 'Junio', 'Julio', 'Agosto',
            'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
        ],
        shortMonths: [
            'E', 'F', 'M', 'A',
            'M', 'J', 'Jl', 'Ag',
            'S', 'O', 'N', 'D'
        ],
        weekdays: [
            'Domingo', 'Lunes', 'Martes', 'Miercoles',
            'Jueves', 'Viernes', 'Sabado'
        ],
        shortWeekdays: ['D','L' ,'M', 'Mi', 'J', 'V', 'S']
    }
}) 


class Movistar extends Component {

    
    constructor(props) {
        super(props);
        //console.log(props.objective)
        //console.log(moment(props.period.startDate).format("YYYY-MM-DD"))
        //console.log(props.toggleCustom)
        this.state = {
            objectiveId:this.props.objective.objetivo_id,
            name:this.props.objective.name,
            serviceObjective:this.props.objective.servicio,
            nodes:this.props.objective.nodos,
            step:this.props.objective.paso,
            sla_ok:this.props.objective.sla_performance,
            sla_e:this.props.objective.sla_error_performance,
            isLoading:true,
            chartOptions: this.chartOptions,
            user:this.props.user,
            begin:moment(this.props.period.startDate).format("YYYY-MM-DD"),
            final:moment(this.props.period.endDate).add({'days':1}).format("YYYY-MM-DD"),
            toggleCustom:props.toggleCustom
        }
        
    }

    static getDerivedStateFromProps(props, state) {
        //console.log('derived', props.objective.paso, state.step)
        if(props.toggleCustom!== state.toggleCustom){
            return {
                toggleCustom:props.toggleCustom,
                begin:moment(props.period.startDate).format("YYYY-MM-DD"),
                final:moment(props.period.endDate).add({'days':1}).format("YYYY-MM-DD"),
                isLoading: true,
            }
        }
        if(props.objective.objetivo_id!==state.objectiveId) {
            return {
                objectiveId:props.objective.objetivo_id,
                serviceObjective:props.objective.servicio,
                name:props.objective.name,
                isLoading: true,
                nodes:props.objective.nodos,
                step:props.objective.paso,
                sla_ok:props.objective.sla_performance,
                sla_e:props.objective.sla_error_performance,
            }
        }
        if(props.objective.paso!==state.step) {
            return {
                objectiveId:props.objective.objetivo_id,
                serviceObjective:props.objective.servicio,
                name:props.objective.name,
                isLoading: true,
                nodes:props.objective.nodos,
                step:props.objective.paso,
                sla_ok:props.objective.sla_performance,
                sla_e:props.objective.sla_error_performance,
            }
        }
        if(props.objective.sla_performance!== state.sla_ok) {
            return {
                objectiveId:props.objective.objetivo_id,
                serviceObjective:props.objective.servicio,
                name:props.objective.name,
                isLoading: true,
                nodes:props.objective.nodos,
                step:props.objective.paso,
                sla_ok:props.objective.sla_performance,
                sla_e:props.objective.sla_error_performance,
            }
        }
        return null;
    }

    componentDidMount() {
        this.getDataFromAPI();
    }

    getDataFromAPI = () => {
        const {user, objectiveId, step, sla_ok, sla_e, begin, final}=this.state
        //console.log('from api',user,begin, final,objectiveId, step, sla_ok, sla_e)
        //console.log(`http://localhost:8082/reporte/especial/AvailabilityResponseStep/?user=${user}&begin=${begin}&final=${final}&data=${objectiveId},${step},${sla_ok},${sla_e},true,false&data_nodo=${objectiveId}:${nodes}:&type=normal&filter=false&time=&historic=true&insert=false`)
        getObjectiveAvailabilityResponse(user,begin, final,objectiveId, step, sla_ok, sla_e).then( data => {
            //console.log('movistar',data)
            this.processData(data[0])
        })
        
    }

    componentDidUpdate(prevProps, prevState) {
        //console.log('updt',prevProps.objective.sla_performance, this.state.sla_ok, prevState.sla_ok)
        if(prevProps.objective.objetivo_id!== this.state.objectiveId||
            prevProps.toggleCustom!== this.state.toggleCustom||
            prevProps.objective.sla_performance!== prevState.sla_ok||
            prevProps.objective.paso!== this.state.step){
            //console.log('up')
            this.getDataFromAPI(); 
        }

    }
    componentWillUnmount() {

    }

    

    // Helper para procesar la data de la petición a la API

    processData = (data)=>{
        
        data.globales.sort(function (a, b) {
            return (moment(a.fecha)-moment(b.fecha));
        });
        //CREAR HISTORICO
        var listCategoryHistoric=[]
        var dataHistoricPerf=[]
        var dataHistoricPerfParcial=[]
        var dataHistoricPerfError=[]
        var dataHistoricAveragePerf=[]
        var minusCatHistoric=[]
        Object.keys(data.historico).forEach(ele=>{
            //console.log(Object.keys(data.historico[ele])[0])
            var dataMonth=(data.historico[ele][Object.keys(data.historico[ele])[0]])[0]
            //console.log(dataMonth.enero)
            dataHistoricPerf.push(parseFloat(dataMonth.perf_ok))
            //console.log(dataMonth.perf_parcial)
            dataHistoricPerfParcial.push(parseFloat(dataMonth.perf_parcial))
            //console.log(dataMonth.perf_error)
            dataHistoricPerfError.push(parseFloat(dataMonth.perf_error))
            //console.log(dataMonth.promedio)
            dataHistoricAveragePerf.push(parseFloat(dataMonth.promedio))
            var category=(Object.keys(data.historico[ele])[0])
            category=category.slice(0,3)
            listCategoryHistoric.push(category)
            minusCatHistoric.push(category.toLocaleLowerCase())
        })

        //CREA DIARIO
        var listDays=[]
        var listperf=[]
        var listperfParcial=[]
        var listError=[]
        var listAverage=[]
        var listMonth=[]
        var min=Infinity
        var max=0
        var perfExtra=0
        var perfExtraMonth=""
        var perfExtraError=0
        var perfExtraParcial=0
        var perfExtraAverage=0
        var contExtra=0
        var arrayMonth=['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre']
        var monthToDay=(moment().month())
        //console.log(arrayMonth.length, arrayMonth[monthToDay])
        Object.keys(data.globales).map(globales=>{
            //console.log(data.globales[globales])
            var month=(moment(data.globales[globales].fecha).format("MMMM"))
            listMonth.push(month)
            //console.log(month)
            //console.log(minusCatHistoric.indexOf(month))
            if(month===arrayMonth[monthToDay]){
                contExtra++
                perfExtraMonth=month
                perfExtra+=data.globales[globales].performance_global
                perfExtraError+=data.globales[globales].error_global
                perfExtraParcial+=data.globales[globales].parcial_global
                perfExtraAverage+=data.globales[globales].promedio_global
            }
            
            var dateJson=(data.globales[globales].fecha).split("-")
            dateJson=Date.UTC(parseInt(dateJson[0]),parseInt(dateJson[1])-1,parseInt(dateJson[2]))
            listDays.push(data.globales[globales].dia)
            listperf.push([dateJson,data.globales[globales].performance_global])
            listperfParcial.push([dateJson,data.globales[globales].parcial_global])
            listError.push([dateJson,data.globales[globales].error_global])
            listAverage.push([dateJson,data.globales[globales].promedio_global])
            if(max<dateJson){
                max=dateJson
            }
            if(min>dateJson){
                min=dateJson
            }
        })
        //console.log(perfExtra, perfExtraParcial, perfExtraError, contExtra)
        
        if(contExtra>0){
            dataHistoricPerf.push(parseFloat((perfExtra/contExtra).toFixed(1)))
            dataHistoricPerfParcial.push(parseFloat((perfExtraParcial/contExtra).toFixed(1)))
            dataHistoricPerfError.push(parseFloat((perfExtraError/contExtra).toFixed(1)))
            dataHistoricAveragePerf.push(parseFloat((perfExtraAverage/contExtra).toFixed(1)))
            listCategoryHistoric.push((perfExtraMonth.charAt(0).toUpperCase() + perfExtraMonth.slice(1)).slice(0,3))
        }
        var newListMonth=new Set(listMonth)
        var primero =true
        var nameMonth=""
        for ( let value of newListMonth.values() ) {
            value=value.charAt(0).toUpperCase() + value.slice(1)
            if(primero===true){
                nameMonth=value
                primero =false
            }else{
                nameMonth+='-'+value
            }
        }
        //console.log(nameMonth)
        //console.log(listCategoryHistoric)
        //console.log((perfExtra/contExtra).toFixed(2),perfExtraMonth,perfExtraError/contExtra,perfExtraParcial/contExtra,perfExtraAverage/contExtra)
        //console.log(listperf, max, min)
        //console.log(listperfParcial)
        extra={}
        if(perfExtraMonth!==""){
            var extra={"perf":(perfExtra/contExtra).toFixed(2),"mes":perfExtraMonth,"error":(perfExtraError/contExtra).toFixed(2),"parcial":(perfExtraParcial/contExtra).toFixed(2),
                        "promedio":(perfExtraAverage/contExtra).toFixed(2)}
        }
        this.props.infoData(data, extra)
        this.setState({
            listCategoryHistoric:listCategoryHistoric,
            dataHistoricPerf:dataHistoricPerf,
            dataHistoricPerfParcial:dataHistoricPerfParcial,
            dataHistoricPerfError:dataHistoricPerfError,
            dataHistoricAveragePerf:dataHistoricAveragePerf,
            listDays:listDays,
            listperf:listperf,
            listperfParcial:listperfParcial,
            listError:listError,
            listAverage:listAverage,
            listMonth:listMonth,
            nameMonth:nameMonth,
            chartOptions: {
                
                xAxis: {
                    type: 'datetime',
                    tickInterval: 24 * 3600 * 1000,
                    dateTimeLabelFormats: {
                        day:  "%e%a %b"  //%a,
                    },
                    min: min,
                    max: max,
                    labels: {
                        style: {
                            fontFamily: 'Montserrat',
                            fontSize:"0.48rem",
                            fontWeight:"bold",
                        }
                    }
                    
                },
                yAxis:[{ // Primary yAxis
                    gridLineColor: "transparent",
                    minorGridLineWidth: -1,
                    endOnTick: true,
                    startOnTick: true,
                    tickPositions: [0, 100],
                    max: 100,
                    min: 0,
                    title: {
                        text: "Performances(%)"
                    },
                    labels: {
                        enabled: true,
                        
                    }
                }, { // Secondary yAxis
                    endOnTick: false,
                    startOnTick: false,
                    tickPositions: [0,15],
                    max: 52,
                    min: -2,
                    opposite: true,
                    gridLineColor: "transparent",
                    minorGridLineWidth: 0,
                    title: {
                        text: "Tiempo de Respuesta(segs.)"
                    },
                    labels: {
                        enabled: true
                    }
                }],
                title: {
                    text: "Diario"
                },
                credits: {
                    enabled: false
                },
                plotOptions: {
                    column: {
                        stacking: 'percent',
                        dataLabels: {
                            enabled: true,
                            style: {
                                fontSize:"0.6rem",
                                fontWeight: 'initial',
                                textOutline: false,
                                color:"#12193c",
                                fontFamily: 'Montserrat',
                            }
                        },
                        enableMouseTracking: false
                    },
                    spline: {
                        color:"red",
                        dataLabels: {
                            enabled: true,
                            style: {
                                fontSize:"0.65rem",
                                fontWeight: 'initial',
                                textOutline: false,
                                fontFamily: 'Montserrat',
                                //color:"white"
                            }
                        },
                        enableMouseTracking: false
                    },

                },
                series: [
                    {
                        pointInterval: 24 * 3600 * 1000, // one day
                        type: 'column',
                        name: 'Indisponibilidad',
                        color:"#ffa000",
                        //index:0,
                        yAxis: 0,
                        data: listError,
                        dataLabels:{
                            enabled: true,
                            style: {fontSize:"0.55rem"},
                            //crop: false,
                            //overflow: 'none',
                            //color: '#3a1cb1',
                            //fill:'#3a1cb1',
                            backgroundColor: '#ffa000',
                            //borderWidth: '1',
                            //align: 'center',
                            //x: 0,
                            //y:0
                            y: -13,
                            //rotation: 0,
                        },
                    }, {
                        pointInterval: 24 * 3600 * 1000, // one day
                        type: 'column',
                        name: 'Fuera de SLA',
                        color:"#ffee58",
                        yAxis: 0,
                        //index:0,
                        data: listperfParcial,
                        dataLabels:{
                            //color: '#000000',
                            backgroundColor: '#ffee58',
                            borderWidth: '1',
                            style: {fontSize:"0.56rem", position: 'absolute'},
                            //align: 'center',
                            //x: 0,
                            y:16
                            //y: 10,
                            //rotation: 0,
                        }
                    }, {
                        pointInterval: 24 * 3600 * 1000, // one day
                        type: 'column',
                        name: 'Perf. 15 seg',
                        color:"#7cb342",
                        yAxis: 0,
                        //index:0,
                        data: listperf,
                        dataLabels:{
                            //enabled: true,
                            //color: '#000000',
                            backgroundColor: '#7cb342',
                            borderWidth: '1',
                            style: {fontSize:"0.56rem"},
                            //align: 'center',
                            y:-15,
                        }
                    }, {
                        pointInterval: 24 * 3600 * 1000, // one day
                        type: 'spline',
                        name: 'promedio',
                        yAxis: 1,
                        //index:1,
                        data: listAverage,
                        marker: {
                            lineWidth: 1,
                            lineColor: "red",
                            fillColor: 'red'
                        },
                        dataLabels:{
                            enabled: true,
                            color: 'white',
                            backgroundColor: 'red',
                            borderWidth: '1',
                            align: 'center',
                            y:40,
                            rotation: 0,
                            style: {fontSize:"0.56rem"}
                        }
                    }
                ]
            },chartOptions2: {
                credits: {
                    enabled: false
                },
                xAxis: {
                    categories: listCategoryHistoric,
                    labels: {
                        style: {
                            fontFamily: 'Montserrat',
                            fontSize:"0.5rem",
                            fontWeight:"bold",
                        }
                    }
                },
                title: {
                    text: "Historico"
                },
                yAxis:[{ // Primary yAxis
                    gridLineColor: "transparent",
                    minorGridLineWidth: -1,
                    endOnTick: true,
                    startOnTick: true,
                    tickPositions: [0, 100],
                    max: 100,
                    min: 0,
                    title: {
                        text: "Performances(%)"
                    },
                    labels: {
                        enabled: true
                    }
                }, { // Secondary yAxis
                    endOnTick: false,
                    startOnTick: false,
                    tickPositions: [0,15],
                    max: 52,
                    min: -2,
                    opposite: true,
                    gridLineColor: "transparent",
                    minorGridLineWidth: 0,
                    title: {
                        text: "Tiempo de Respuesta(segs.)"
                    },
                    labels: {
                        enabled: true
                    }
                }],
                plotOptions: {
                    column: {
                        stacking: 'percent',
                        dataLabels: {
                            enabled: true,
                            style: {
                                fontSize:"0.64rem",
                                fontWeight: 'initial',
                                textOutline: false,
                                color:"#12193c",
                                fontFamily: 'Montserrat',
                            }
                        },
                        enableMouseTracking: false
                    },
                    spline: {
                        color:"red",
                        dataLabels: {
                            enabled: true,
                            style: {
                                fontSize:"0.64rem",
                                fontWeight: 'initial',
                                textOutline: false,
                                fontFamily: 'Montserrat',
                                //color:"white"
                            }
                        },
                        enableMouseTracking: false
                    },
                },
                series: [
                    {
                        type: 'column',
                        name: 'Indisponibilidad',
                        color:"#ffa000",
                        data: dataHistoricPerfError,
                        dataLabels:{
                            enabled: true,
                            style: {fontSize:"0.56rem"},
                            //crop: false,
                            //overflow: 'none',
                            //color: '#3a1cb1',
                            //fill:'#3a1cb1',
                            backgroundColor: '#ffa000',
                            //borderWidth: '1',
                            //align: 'center',
                            //x: 0,
                            //y:0
                            y: -13,
                            //rotation: 0,
                        }
                    }, 
                    
                    {
                        type: 'column',
                        name: 'Fuera de SLA',
                        color:"#ffee58",
                        yAxis: 0,
                        //index:0,
                        data: dataHistoricPerfParcial,
                        dataLabels:{
                            color: '#000000',
                            backgroundColor: '#ffee58',
                            borderWidth: '1',
                            align: 'center',
                            /* x: 0, */
                            y: 22,
                            rotation: 0,
                            style: {fontSize:"0.56rem"},
                        }
                    }, 
                    
                    {
                        type: 'column',
                        name: 'Perf. 15 seg',
                        color:"#7cb342",
                        yAxis: 0,
                        //index:0,
                        data: dataHistoricPerf,
                        dataLabels:{
                            enabled: true,
                            color: '#000000',   
                            backgroundColor: '#7cb342',
                            borderWidth: '1',
                            align: 'center',
                            y:-20,
                            rotation: 0,
                            style: {fontSize:"0.56rem"},
                        }
                    },
                    {
                        type: 'spline',
                        name: 'promedio',
                        yAxis: 1,
                        //index:1,
                        data: dataHistoricAveragePerf,
                        marker: {
                            lineWidth: 1,
                            lineColor: "red",
                            fillColor: 'red'
                        },
                        dataLabels:{
                            enabled: true,
                            color: 'white',
                            backgroundColor: 'red',
                            borderWidth: '1',
                            align: 'center',
                            y:40,
                            rotation: 0,
                            style: {fontSize:"0.56rem"}
                        }
                    }
                ]
            },
            nameObjective:data.nombre_objetivo,
            stepName:data.paso.nombre_paso,
            dataError: false,
            isLoading: false,
        });

    }

    createCell=(i, perfHistoric, dataLength, order)=>{
        const {classes}=this.props
        //console.log(i, perfHistoric, dataLength-1)
        var cell=<TableCell className={classes.cell} key={perfHistoric} ><Typography className={classes.typoMont} variant="caption">{i}</Typography></TableCell>
        
        if(perfHistoric===dataLength-1){
            cell=<TableCell className={classes.cellWhiteRight} key={perfHistoric} ><Typography className={classes.typoMont} variant="caption">{i}</Typography></TableCell>
        }
        if(order===1){
            //console.log(i, perfHistoric, dataLength, order)
            var cell=<TableCell className={classes.cellWhiteBottom} key={perfHistoric} ><Typography className={classes.typoMont} variant="caption">{i}</Typography></TableCell>
            if(perfHistoric===dataLength-1){
                //console.log(i, perfHistoric, dataLength, order)
                cell=<TableCell className={classes.cellWhiteRightBottom} key={perfHistoric} ><Typography className={classes.typoMont} variant="caption">{i}</Typography></TableCell>
            }
        }
        
        return cell
    }

    createTableHistoric=()=>{
        const {listCategoryHistoric, listDays, nameMonth, serviceObjective,nameObjective, listperf,dataHistoricPerf, listperfParcial,
             dataHistoricPerfParcial, listError, dataHistoricPerfError, listAverage, dataHistoricAveragePerf}=this.state
        const {classes}=this.props
        var serviceName='Desktop'
        if(serviceObjective===700){
            serviceName='App'
        }
        //console.log(listperf, dataHistoricPerf)
        //console.log(listCategoryHistoric, listDays, listMonth)
        var table=
            <Table >
                <TableBody >
                    <TableRow>
                        <TableCell className={classes.cellGrey} rowSpan={2} ><Typography className={classes.typoMont}>Plataforma</Typography></TableCell>
                        <TableCell className={classes.cellGrey}  rowSpan={2}><Typography className={classes.typoMont}>Kpi's</Typography></TableCell>
                        <TableCell className={classes.cellWhite} colSpan={listCategoryHistoric.length}><Typography className={classes.typoMont}>Meses</Typography></TableCell>
                        <TableCell className={classes.cellBlueGrey} colSpan={listDays.length}><Typography className={classes.typoMont}>{nameMonth}</Typography></TableCell>
                    </TableRow>
                    <TableRow>
                        {listCategoryHistoric.map(ele=>(
                            <TableCell className={classes.cellGrey} key={ele}><Typography variant="caption" className={classes.typoMont} style={{fontWeight:"600"}}>{ele}</Typography></TableCell>
                        ))}
                        {listDays.map(ele=>(
                            <TableCell className={classes.cellBlueGrey} key={ele}><Typography variant="caption" className={classes.typoMont}>{ele}</Typography></TableCell>
                        ))}     
                    </TableRow>
                    <TableRow>
                        <TableCell className={classes.cellWhite} rowSpan={5}><Typography className={classes.typoMont}>{serviceName}</Typography></TableCell>
                        <TableCell className={classes.cellGrey}><Typography className={classes.typoMont}>{nameObjective}</Typography></TableCell>
                        <TableCell className={classes.cellWhiteRightLeft} colSpan={listCategoryHistoric.length}></TableCell>
                        <TableCell className={classes.cellWhiteRightLeft} colSpan={listDays.length}></TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className={classes.cellWhiteRightLeft} style={{textAlign:"left"}}><Typography className={classes.typoMont}>Perf 15 seg.</Typography></TableCell>
                        {dataHistoricPerf.map((i,perfHistoric)=>(
                            this.createCell(i, perfHistoric, dataHistoricPerf.length, 0)
                            
                        ))}
                        {listperf.map((perf, index)=>(
                            this.createCell(perf[1], index, listperf.length,0)
                        ))}
                    </TableRow>
                    <TableRow>
                        <TableCell className={classes.cellWhiteRightLeft} style={{textAlign:"left"}}><Typography className={classes.typoMont}>Fuera de Sla</Typography></TableCell>
                        {dataHistoricPerfParcial.map((i,perfHistoric)=>(
                            this.createCell(i, perfHistoric, dataHistoricPerf.length,0)
                            
                        ))}
                        {listperfParcial.map((perf, index)=>(
                            this.createCell(perf[1], index, listperf.length,0)
                        ))}
                    </TableRow>
                    <TableRow>
                        <TableCell className={classes.cellWhiteRightLeft} style={{textAlign:"left"}}><Typography className={classes.typoMont}>Indisponibilidad/Error</Typography></TableCell>
                        {dataHistoricPerfError.map((i,perfHistoric)=>(
                            this.createCell(i, perfHistoric, dataHistoricPerf.length,0)
                            
                        ))}
                        {listError.map((perf, index)=>(
                            this.createCell(perf[1], index, listperf.length,0)
                        ))}
                    </TableRow>
                    <TableRow>
                        <TableCell className={classes.cellWhiteRightLeftBottom} style={{textAlign:"left"}}><Typography className={classes.typoMont}>Tiempo de Respuesta</Typography></TableCell>
                        {dataHistoricAveragePerf.map((i,perfHistoric)=>(
                            this.createCell(i, perfHistoric, dataHistoricPerf.length,1)
                            
                        ))}
                        {listAverage.map((perf, index)=>(
                            this.createCell(perf[1], index, listperf.length,1)
                        ))}
                    </TableRow>
                </TableBody>
            </Table>
        return table
    }
    render() {
        const {isLoading, chartOptions, chartOptions2, nameObjective,stepName}=this.state
        
        const {classes}= this.props
        if (isLoading===false)  {
            return(
                <Grid
                    container
                    spacing={1}
                >
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        xl={12}
                        style={{textAlign:"center"}}
                    >
                        <Typography className={classes.Mont} variant="h4">{nameObjective} </Typography>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        xl={12}
                        style={{textAlign:"center"}}
                    >
                        <Typography className={classes.Mont} variant="h6">Paso: {stepName} </Typography>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={4}
                        xl={4}
                    >
                        <PerfectScrollbar>
                            <HighchartsReact
                                highcharts={Highcharts}
                                options={chartOptions2} />
                        </PerfectScrollbar>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={8}
                        xl={8}
                    >
                        <PerfectScrollbar>
                            <HighchartsReact
                                highcharts={Highcharts}
                                options={chartOptions} />
                        </PerfectScrollbar>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        xl={12}
                    >
                        {this.createTableHistoric()}
                    </Grid>
                </Grid>
            )
        } else {
            return (
                <PortletContent>
                    <div>      
                        <Typography
                            
                            variant="h5">
                            <CircularProgress
                                variant="indeterminate"      
                                size={24}
                                thickness={4}                            
                            />
                            Cargando Información...
                        </Typography>        
                    </div>
            </PortletContent>
            )
        }
    }
}



//export default (Movistar);

export default compose(withStyles(styles))(Movistar);


// WEBPACK FOOTER //
// ./src/layouts/components/content/Movistar/index.jsx